export const MAIN_ROUTE = "/";
export const ENTREPRENEURS_ROUTE = "/dla_przedsiebiorcow";
export const SLS_ROUTE = "/sls";
export const KEEP_UP_ROUTE = "/badz_na_biezaco";
export const ARTISTS_ROUTE = "/dla_artystow";
export const SZCZECIN_SCHOOL_ROUTE = "/gotowi_do_szkoly";
export const ADMINISTRATION_ROUTE = "/zalatw_sprawe_w_urzedzie";
export const INFO_ROUTE = "/obostrzenia";
export const VACCINATION_ROUTE = "/szczepienia";
export const NEIGHBOUR_ROUTE = "/pomoc_sasiedzka_jak_sie_masz";
export const VOLUNTARY_ROUTE = "/wolontariat";
export const CALL_ROUTE = "/seniorzy";



export const HELP_ROUTE = "/pomoc";
export const HOUSE_ROUTE = "/mieszkanie";
export const EDUCATION_ROUTE = "/edukacja";
export const WORK_ROUTE = "/praca";


export const WORK_ROUTE_LINK = "https://szczecin.praca.gov.pl/documents/4284075/17462126/Ulotka_Oferty_Pracy_PL.pdf/035a450f-08f9-4ac7-8fd6-96504da2ff4f?t=1646402768906";
export const WORK_ROUTE_LINK_UA = "https://szczecin.praca.gov.pl/documents/4284075/17462126/Ulotka_Oferty_Pracy_UA.pdf/deb67c9c-b964-4912-a08e-16e62bc42dc3?t=1646402768737";